import React from 'react'
import styled, { css } from 'styled-components'
import { down } from 'styled-breakpoints'
import { Link, useLocation } from 'react-router-dom'
import { ReactComponent as LogoIcon } from '../../assets/svg/logo.svg'
import { ReactComponent as MenuIcon } from '../../assets/svg/menu.svg'
import Stores from '../common/Stores'
import { TABLET } from '../../lib/constant'

const ROUTES = {
	home: '/',
	faq: '/faq',
	contact: '/contact',
}

export default function Header() {
	const { pathname } = useLocation()

	return (
		<HeaderBlock>
			<ResponsiveBlock>
				<StyledLink to="/">
					<Logo />
				</StyledLink>
				<MobileMenu>
					<MenuIcon />
				</MobileMenu>
				<DesktopMenu>
					<Navigation>
						<NavItem to={ROUTES.home} selected={pathname === ROUTES.home}>
							서비스 소개
						</NavItem>
						<NavItem to={ROUTES.faq} selected={pathname === ROUTES.faq}>
							자주묻는질문
						</NavItem>
						<NavItem to={ROUTES.contact} selected={pathname === ROUTES.contact}>
							문의하기
						</NavItem>
					</Navigation>
					<Stores />
				</DesktopMenu>
			</ResponsiveBlock>
		</HeaderBlock>
	)
}

const HeaderBlock = styled.header`
	height: var(--header-height);
	width: 100%;
	box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.1);
	position: relative;
	z-index: 99;
	background-color: white;
`

const StyledLink = styled(Link)`
	width: 100px;
	position: relative;
	z-index: 3;
`

const Logo = styled(LogoIcon)``

const Navigation = styled.nav`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
`

const NavItem = styled(Link)`
	display: inline-flex;
	font-weight: 700;
	font-size: 18px;
	line-height: 24px;
	cursor: pointer;
	white-space: nowrap;

	& + & {
		margin-left: 32px;
	}

	&:hover {
		border-bottom: 2px solid black;
	}

	${({ selected }) =>
		selected &&
		css`
			color: #eb4c60;
			border-bottom: 2px solid #eb4c60;
			&:hover {
				border-bottom: 2px solid #eb4c60;
			}
		`}
`

const ResponsiveBlock = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 100%;
	padding-left: 16px;
	padding-right: 16px;
`

const MobileMenu = styled.div`
	cursor: pointer;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	display: none;
	${down(TABLET)} {
		display: block;
	}
`

const DesktopMenu = styled.div`
	display: flex;
	align-items: center;
	${down(TABLET)} {
		display: none;
	}
`
